import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Reports() {
    const [reports, setReports] = useState([]);
    const [filter, setFilter] = useState("all");
    const [loading, setLoading] = useState(true);
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        Promise.all([api.get("/reports"), api.get("/companies")])
            .then(([r1, r2]) => { setReports(r1.data); setCompanies(r2.data); })
            .finally(() => setLoading(false));
    }, []);

    const filtered = filter === "all" ? reports : reports.filter((r) => r.company_id === filter);

    return (
        <div className="p-8 lg:p-10 max-w-[1400px]" data-testid="reports-page">
            <div className="mb-8">
                <div className="overline mb-2">Archive</div>
                <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tighter leading-none">REPORTS</h1>
                <p className="text-sm text-muted2 mt-2">Every uploaded daily report, parsed and indexed.</p>
            </div>
            <div className="mb-4 flex flex-wrap gap-2">
                <button
                    onClick={() => setFilter("all")}
                    data-testid="filter-all"
                    className={`px-3 py-1.5 text-xs rounded-sm border transition-colors ${filter === "all" ? "bg-ink text-paper border-ink" : "bg-surface border-rule hover:border-ink"}`}
                >All</button>
                {companies.map((c) => (
                    <button
                        key={c.id}
                        onClick={() => setFilter(c.id)}
                        data-testid={`filter-${c.slug}`}
                        className={`px-3 py-1.5 text-xs rounded-sm border transition-colors ${filter === c.id ? "bg-ink text-paper border-ink" : "bg-surface border-rule hover:border-ink"}`}
                    >{c.name}</button>
                ))}
            </div>
            {loading ? (
                <div className="overline">Loading…</div>
            ) : filtered.length === 0 ? (
                <div className="grid-card p-12 text-center">
                    <div className="overline mb-2">Empty archive</div>
                    <div className="text-sm text-muted2 mb-4">No reports match this filter yet.</div>
                    <Link to="/upload" className="btn-primary inline-flex" data-testid="empty-upload-cta">Upload your first report</Link>
                </div>
            ) : (
                <div className="grid-card overflow-hidden">
                    <table className="w-full text-sm">
                        <thead className="bg-paper border-b border-rule text-left">
                            <tr>
                                <th className="overline px-4 py-3">Date</th>
                                <th className="overline px-4 py-3">Company</th>
                                <th className="overline px-4 py-3">Type</th>
                                <th className="overline px-4 py-3">Headline</th>
                                <th className="overline px-4 py-3">Filed by</th>
                                <th className="overline px-4 py-3">Imgs</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((r) => (
                                <tr key={r.id} className="border-t border-rule hover:bg-paper transition-colors">
                                    <td className="px-4 py-3 data-num">{r.report_date}</td>
                                    <td className="px-4 py-3 font-medium">{r.company_name}</td>
                                    <td className="px-4 py-3">
                                        <span className={`px-2 py-0.5 text-[10px] uppercase tracking-wider rounded-sm border ${r.report_type === "financial" ? "border-klein text-klein" : "border-ink text-ink"}`}>
                                            {r.report_type === "financial" ? "Finance" : "Ops"}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3 text-muted2 max-w-md truncate">
                                        <Link to={`/reports/${r.id}`} className="hover:underline text-ink" data-testid={`report-link-${r.id}`}>
                                            {r.extracted?.headline || r.summary || "(no headline)"}
                                        </Link>
                                    </td>
                                    <td className="px-4 py-3 text-muted2">{r.uploader_name}</td>
                                    <td className="px-4 py-3 data-num">{r.image_count}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
